<script>
	import * as rive from '@rive-app/canvas-lite';
	import { PAGES, QUERY_PARAM_VALUES, QUERY_PARAM_KEYS } from '$lib/utils/constants';
	import rivFile from '$lib/assets/images/home/abcmouse_landing_rive_v1.riv';
	import { goto } from '$app/navigation';
	import { onMount } from 'svelte';
	export let content = {
		title: '',
		subTitle: '',
		offer: '',
		offerDisclaimer: '',
		cta: '',
		subTitleDisclaimer: '',
		offerBadgeImgSrc: '',
		offerBadgeImgAltTxt: ''
	};

	function initializeRive() {
		const canvasElement = document.getElementById('canvas');
		const r = new rive.Rive({
			src: rivFile,
			canvas: canvasElement,
			autoplay: true,
			stateMachines: 'State Machine 1',
			onLoad: () => {
				r.resizeDrawingSurfaceToCanvas();
			}
		});
	}

	onMount(() => {
		initializeRive();
	});
</script>

<section
	class="relative my-[1rem] grid w-full grid-cols-1 items-center justify-items-center sm:my-[1rem] md:my-[0rem] md:grid-cols-2 lg:my-20 lg:justify-center"
>
	<canvas
		id="canvas"
		width="500"
		height="500"
		class="w-full max-w-[24.8em] pl-[1rem] pr-[1rem] sm:max-w-[38.6rem] md:mr-[-7rem] md:max-w-[67.6rem] md:justify-self-end"
	></canvas>
	<div
		class="flex w-full flex-col items-center sm:max-w-[52rem] sm:justify-center md:ml-[5rem] md:mt-[11rem] md:justify-self-start"
	>
		<h1 class="mt-[0rem] flex flex-col pb-[0.6rem] text-center sm:mt-[-2rem] sm:pb-1">
			<p
				class="bg-gradient-to-r from-[#8A1DBB] to-[#2B57CF] bg-clip-text text-[2.17rem] font-regular leading-[2.3rem] tracking-[.04rem] text-transparent sm:pb-2 sm:text-[4.1rem] sm:leading-[5rem]"
			>
				{@html content.title}
			</p>
		</h1>

		<p
			class="bg-white font-poppins text-[1.3rem] font-medium text-[#63637a] sm:text-[2.1rem]"
		>
			{@html content.subTitle}
		</p>
		<button
			id="nmhp-cta"
			class="btn-primary-red mt-2 h-[3.9rem] w-[26rem] font-poppins text-[1.7rem] font-bold sm:mt-[3rem] sm:h-[5.5rem] sm:w-[40rem] sm:text-[2.3rem]"
			on:click|preventDefault={() => {
				goto(PAGES.INTERNAL.SUBSCRIPTION);
			}}
		>
			{content.cta}
		</button>
    <p
      class="bg-gradient-to-r from-[#8A1DBB] to-[#2B57CF] bg-clip-text text-transparent mt-[1.2rem] font-poppins text-[1.2rem] sm:mb-6 md:text-[1.6rem] justify-center font-regular"
    >
      {@html content.subTitleDisclaimer}
    </p>
	</div>
	<a
		id="direct-annual-cta"
		href={PAGES.INTERNAL.SUBSCRIPTION +
			`?${QUERY_PARAM_KEYS.PRODUCT_TYPE}=${QUERY_PARAM_VALUES.B_TERM.ANNUAL}`}
		class="mt-[3.2rem] w-[15.4rem] sm:absolute sm:right-[calc(50%-28rem)] sm:top-[-5rem] sm:w-[15.5rem] md:right-[calc(50%-60rem)] md:top-[-6.5rem] md:w-[20.5rem]"
	>
		<img
			src={content.offerBadgeImgSrc}
			alt={content.offerBadgeImgAltTxt}
			data-track-id="direct-annual-cta"
		/>
	</a>
</section>
